/*
import api from "../services/api"; // axios instance with baseURL = "http://localhost/api"

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export default function CategoryFilter({ value, onChange }: Props) {
  return (
    <select
      className="form-select mb-4"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">All Categories</option>
      <option value="Skin Butter">Skin Butter</option>
      <option value="Lotion">Lotion</option>
      <option value="Medicinal">Medicinal</option>
    </select>
  );
}
*/

// src/components/CategoryFilter.tsx
// src/components/CategoryFilter.tsx
// src/components/CategoryFilter.tsx
// src/components/CategoryFilter.tsx
// src/components/CategoryFilter.tsx
/*
import { useEffect, useState } from "react";
import api from "../services/api";
import { PaginatedResponse } from "../types/api";

interface Category {
  id: number;
  name: string;
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  onFilter: (category: string) => void; // ✅ just passes category string to parent
}

export default function CategoryFilter({ value, onChange, onFilter }: Props) {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState<PaginatedResponse<Category> | null>(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const res = await api.get<PaginatedResponse<Category>>("/categories", {
          params: { page },
        });
        setCategories(res.data.data);
        setPagination(res.data);
      } catch (err) {
        console.error("Failed to load categories", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, [page]);

  const handleChange = (selected: string) => {
    onChange(selected);
    onFilter(selected); // ✅ trigger reload in parent
  };

  const handleLiveSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    onChange(val);
    onFilter(val); // ✅ trigger reload in parent
  };

  return (
    <div className="mb-4">
      <select
        className="form-select mb-2"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
      >
        <option value="">All Categories</option>
        {loading && <option disabled>Loading...</option>}
        {!loading &&
          categories.map((cat) => (
            <option key={cat.id} value={cat.name}>
              {cat.name}
            </option>
          ))}
      </select>

      <input
        type="text"
        className="form-control mb-2"
        placeholder="Search category..."
        value={value}
        onChange={handleLiveSearch}
      />

      {/ ✅ Pagination controls for categories /}
      {pagination && (
        <nav>
          <ul className="pagination">
            {Array.from({ length: pagination.last_page }, (_, i) => (
              <li
                key={i}
                className={`page-item ${page === i + 1 ? "active" : ""}`}
              >
                <button className="page-link" onClick={() => setPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </div>
  );
}

*/


// src/components/CategoryFilter.tsx
import { useEffect, useState } from "react";
import api from "../services/api";
import { PaginatedResponse } from "../types/api";

interface Category {
  id: number;
  name: string;
}

interface Props {
  value: string;
  onChange: (value: string) => void;
  onFilter: (category: string) => void;
}

export default function CategoryFilter({ value, onChange, onFilter }: Props) {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const res = await api.get<PaginatedResponse<Category>>("/categories");
        setCategories(res.data.data);
      } catch (err) {
        console.error("Failed to load categories", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const handleChange = (selected: string) => {
    onChange(selected);
    onFilter(selected);
  };

  const handleLiveSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    onChange(val);
    onFilter(val);
  };

  return (
    <div className="mb-4">
      <div className="input-group mb-2">
        <span className="input-group-text">📂 Category</span>
        <select
          className="form-select"
          value={value}
          onChange={(e) => handleChange(e.target.value)}
        >
          <option value="">All Categories</option>
          {loading && <option disabled>Loading...</option>}
          {!loading &&
            categories.map((cat) => (
              <option key={cat.id} value={cat.name}>
                {cat.name}
              </option>
            ))}
        </select>
      </div>

      <div className="input-group">
        <span className="input-group-text">🔍</span>
        <input
          type="text"
          className="form-control"
          placeholder="Search category..."
          value={value}
          onChange={handleLiveSearch}
        />
      </div>
    </div>
  );
}





